import axios from 'axios'
import { Message } from 'element-ui'
import router from '@/router'

// 创建 axios 实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 5000
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = "Bearer " + token // 移除 'Bearer ' 前缀
    }
    return config
  },
  error => {
    console.error('请求错误:', error) // 记录请求错误
    return Promise.reject(error) // 直接返回错误
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    
    if (res.code !== 1) {
      // 401: 未登录或token过期
      if (res.code === 401) {
        localStorage.removeItem('token')
        router.push('/login')
      }
      // 统一处理错误
      Message.error(res.msg || '请求失败')
      return Promise.reject(res) // 直接返回错误数据
    } else {
      return res.data
    }
  },
  error => {
    console.error('响应错误:', error) // 记录响应错误
    Message.error(error.message || '网络错误') // 统一处理错误信息
    return Promise.reject(error) // 直接返回错误
  }
)

export default service 